export default __webpack_public_path__ + "static/media/rewards_icon_cultural.07bc6783.svg";